import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, ClipboardPen, ShieldCheck, LogOut, ListTodo, Search } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../context/AuthContext";
import { NotificationBell } from "./NotificationBell";

const NAV = [
  { to: "/feedback", label: "Take Feedback", icon: ClipboardPen, admin: false },
  { to: "/pending", label: "Pending Reviews", icon: ListTodo, admin: false },
  { to: "/search", label: "Guest Search", icon: Search, admin: false },
  { to: "/dashboard", label: "Analytics", icon: LayoutDashboard, admin: true },
  { to: "/admin", label: "Users & Devices", icon: ShieldCheck, admin: true },
];

export const AppHeader = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const items = NAV.filter((n) => !n.admin || user?.role === "admin");
  return (
    <header className="sticky top-0 z-30 glass-strong border-b border-white/80" data-testid="app-header">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-wrap items-center gap-3">
        <Logo />
        <nav className="flex items-center gap-1 ml-0 lg:ml-6 order-3 lg:order-none w-full lg:w-auto overflow-x-auto">
          {items.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={`nav-${to.slice(1)}`}
              className={({ isActive }) =>
                `flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                  isActive ? "bg-emerald-900 text-amber-50" : "text-emerald-900/70 hover:bg-emerald-900/5"
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-3">
          {children}
          {user?.role === "admin" && <NotificationBell />}
          <div className="hidden md:block text-right leading-tight">
            <div className="text-sm font-semibold text-emerald-950" data-testid="header-user-name">{user?.name}</div>
            <div className="text-[11px] uppercase tracking-wider text-slate-500">{user?.role === "admin" ? "Management" : "Feedback Taker"}</div>
          </div>
          <button
            data-testid="logout-button"
            onClick={async () => { await logout(); nav("/login"); }}
            className="h-10 w-10 grid place-items-center rounded-full border border-emerald-900/10 bg-white/80 text-emerald-900 hover:bg-red-50 hover:text-red-600 transition-colors"
            title="Sign out"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
};
